import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import { AiModelStatusError, AiModelStatusRequest, AiModelStatusResponse } from '@/api/model';

const KEY = {
  GET_AI_MODEL_STATUS_BY_STUDY: 'GET_AI_MODEL_STATUS_BY_STUDY',
} as const;

const request = {
  getAiModelStatusByStudy: async (
    { payload: { studyId } }: AiModelStatusRequest,
    signal?: AbortSignal,
  ) => {
    const { data } = await fetchClient.FCT.get<AiModelStatusResponse>(
      `${ENDPOINTS.FCT.AI_MODEL_STATUS.STUDY}${studyId}/model-status`,
      { signal },
    );

    return data;
  },
};

const query = {
  useGetAiModelStatusByStudy: (
    { payload }: AiModelStatusRequest,
    config?: Partial<UseQueryOptions<AiModelStatusResponse, AiModelStatusError>>,
  ) =>
    useQuery<AiModelStatusResponse, AiModelStatusError>({
      queryFn: ({ signal }) => request.getAiModelStatusByStudy({ payload }, signal),
      queryKey: [KEY.GET_AI_MODEL_STATUS_BY_STUDY, payload.studyId],
      ...config,
    }),
};

export const aiModelStatus = {
  KEY,
  query,
  request,
};
